















































































import { defineComponent, ref, onMounted, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'dev-grid',
  components: {},
  setup() {
    const root = ref<HTMLElement | null>(null)
    const isVisible = ref(false)
    const isDev = computed(
      () =>
        process.env.VUE_APP_RELEASE === 'staging' ||
        process.env.VUE_APP_RELEASE === 'development'
    )

    const show = () => {
      root.value!.style.display = 'block'
      isVisible.value = true
    }

    const hide = () => {
      root.value!.style.display = 'none'
      isVisible.value = false
    }

    const toggle = () => {
      // eslint-disable-next-line
      isVisible.value ? hide() : show()
    }

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.shiftKey && e.key === 'G') {
        toggle()
      }
    }

    onMounted(() => {
      if (!isDev) {
        return
      }

      window.addEventListener('keydown', onKeyDown)
    })

    return {
      root,
      isDev,
    }
  },
})
